import React, { useState } from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

const ContactForm = () => {
  const [callbackForm, setCallbackForm] = useState({
    name: '',
    phone: '',
    email: '',
    info: '',
    callTime: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleCallbackSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);
    
    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      
      const response = await fetch(`${API_URL}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: callbackForm.name,
          phone: callbackForm.phone,
          email: callbackForm.email,
          message: callbackForm.info,
          call_time: callbackForm.callTime
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setSubmitStatus({
          type: 'success',
          message: data.message || 'Thank you! We will call you back soon.'
        });
        // Reset form on success
        setCallbackForm({ name: '', phone: '', email: '', info: '', callTime: '' });
      } else {
        setSubmitStatus({
          type: 'error',
          message: data.detail || 'Failed to send your request. Please try again or call us at 734.209.6712'
        });
      }
    } catch (error) {
      console.error('Contact form error:', error);
      setSubmitStatus({
        type: 'error',
        message: 'Unable to send your request. Please call us directly at 734.209.6712'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-10 px-4 bg-blue-50">
      <div className="container mx-auto max-w-2xl">
        <h2 className="text-3xl font-bold text-center mb-6 text-gray-900">Before you choose a plan—let's talk.</h2>
        <p className="text-center text-lg text-gray-700 mb-6">
          You deserve to know your options, the real costs, and how to get the coverage that works for you.<br />
          📞 Contact me today—I'm here to help.
        </p>
        <Card className="border-2 border-teal-200">
          <CardContent className="p-8">
            <form onSubmit={handleCallbackSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
                <Input
                  required
                  value={callbackForm.name}
                  onChange={(e) => setCallbackForm({...callbackForm, name: e.target.value})}
                  placeholder="Your name"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number *</label>
                <Input
                  type="tel"
                  required
                  value={callbackForm.phone}
                  onChange={(e) => setCallbackForm({...callbackForm, phone: e.target.value})}
                  placeholder="(555) 123-4567"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
                <Input
                  type="email"
                  required
                  value={callbackForm.email}
                  onChange={(e) => setCallbackForm({...callbackForm, email: e.target.value})}
                  placeholder="your@email.com"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Information Needed</label>
                <Textarea
                  value={callbackForm.info}
                  onChange={(e) => setCallbackForm({...callbackForm, info: e.target.value})}
                  placeholder="What would you like to discuss?"
                  rows={3}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Good Time to Reach Out</label>
                <Select value={callbackForm.callTime} onValueChange={(value) => setCallbackForm({...callbackForm, callTime: value})}>
                  <SelectTrigger>
                    <SelectValue placeholder="Select a time" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="morning">Morning (8am - 12pm)</SelectItem>
                    <SelectItem value="afternoon">Afternoon (12pm - 5pm)</SelectItem>
                    <SelectItem value="evening">Evening (5pm - 8pm)</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <Button 
                type="submit" 
                disabled={isSubmitting}
                className="w-full bg-teal-600 hover:bg-teal-700 text-white text-lg py-6 disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'Sending...' : 'Request a Call Back'}
              </Button>
              
              {submitStatus && (
                <div className={`mt-4 p-4 rounded-lg text-center font-medium ${
                  submitStatus.type === 'success' 
                    ? 'bg-green-100 text-green-800 border border-green-300' 
                    : 'bg-red-100 text-red-800 border border-red-300'
                }`}>
                  {submitStatus.message}
                </div>
              )}
            </form>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default ContactForm;
